import React from 'react';
import {List, Button, Modal, message, Row, Col, Spin, Divider} from 'antd/lib/index';
import ReactJson from 'react-json-view'
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";

export default class ServersCacheManage extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            showMessageDialog: false,
            showJSONFormatModal: false,
            networkParameters: '',
            formatJSON: [],
            selectedKey: '',
            selectedRedisValue: '',
            selectedMemcachedValue: '',
            showConfirmModal: false,
            redisLoading: false,
            memcachedLoading: false
        }
    }

    componentDidMount() {
        this.loadListData();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value});

        if (name === 'networkParameters') {
            try {
                this.setState({formatJSON: JSON.parse(value)});
            } catch (e) {
                console.log('Invalid JSON data.');
                this.setState({formatJSON: value});
            }
        }
    }

    loadListData() {
        new WebServerRestClient().GET('/admin/redis/keys/fnet')
        .then(response => {
            console.log("query fnet keys response -> " + JSON.stringify(response));
            if (response.code === 200) {
                this.setState({fnetList: response.data, loading: false})
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(response['msg']);
            }
        }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });

        new WebServerRestClient().GET('/admin/redis/keys/pnet')
        .then(response => {
            console.log("query pnet keys response -> " + JSON.stringify(response));
            if (response.code === 200) {
                this.setState({pnetList: response.data, loading: false})
            } else if (response.code === 401 || response.code === 403) {
                this.props.history.push('/login');
            } else {
                message.error(response['msg']);
            }
        }).catch(err => {
            console.error(err);
            message.error("Error: " + err.message);
        });
    }

    async updateServersCache () {
        let requestBody;
        try {
            requestBody = JSON.parse(this.state.networkParameters);
        } catch (err) {
            alert('JSON format error!');
            return;
        }

        this.setState({doing: true});
        for (let i = 0; i < requestBody.length; i++) {
            try {
                const response = await new WebServerRestClient().POST('/admin/network/build_cached_nodes', requestBody[i]);
                if (response) {
                    console.log("sync nodes to web-server response -> " + JSON.stringify(response));
                    if (response.code === 200) {
                        this.loadListData();
                        let itemHTML = document.createElement("div");
                        itemHTML.innerHTML = "completed: " + response.data;
                        document.getElementById('executeTips').appendChild(itemHTML);
                    } else {
                        let itemHTML = document.createElement("div");
                        itemHTML.innerHTML = '<span style="color: red">' + response.msg + '</span>';
                        document.getElementById('executeTips').appendChild(itemHTML);
                    }
                }
            } catch (err) {
                message.error("Error: " + err.message);
            }
        }
        this.setState({doing: false});

    };

    showServersModal(selectedKey){
        this.setState({
            showConfirmModal: true,
            selectedKey: selectedKey,
            redisLoading: true,
            memcachedLoading: true
        });

        // loading redis cache
        new WebServerRestClient().GET('/admin/redis/values/' + selectedKey)
            .then(response => {
                console.log("query redis cache value response -> " + response.code);
                this.setState({redisLoading: false});
                if (response.code === 200) {
                    this.setState({selectedRedisValue: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            message.error("Error: " + err.message);
            this.setState({redisLoading: false});
        });

        // loading memcached value
        new WebServerRestClient().GET('/admin/memcached/values/' + selectedKey)
            .then(response => {
                console.log("query memcached cache value response -> " + response.code);
                this.setState({memcachedLoading: false});
                if (response.code === 200) {
                    this.setState({selectedMemcachedValue: response.data})
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            message.error("Error: " + err.message);
            this.setState({memcachedLoading: false});
        });
    };

    render() {
        return (
            <div className="container">
                <Row>
                    <Col span={12}>
                        <Row>
                            <Col span={12}>
                                <List
                                    style={{border: 'none',marginLeft: 5}}
                                    loading={this.state.loading}
                                    header={<div>Free Network</div>}
                                    bordered
                                    dataSource={this.state.fnetList}
                                    renderItem={item => (
                                        <List.Item>
                                            <a onClick={() => this.showServersModal(item)}>{item}</a>
                                        </List.Item>
                                    )}
                                />
                            </Col>
                            <Col span={12}>
                                <List
                                    style={{border: 'none',marginLeft: 5}}
                                    loading={this.state.loading}
                                    header={<div>Paid Network</div>}
                                    bordered
                                    dataSource={this.state.pnetList}
                                    renderItem={item => (
                                        <List.Item>
                                            <a onClick={() => this.showServersModal(item)}>{item}</a>
                                        </List.Item>
                                    )}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12}>
                        <textarea
                            style={{
                                border: 0,
                                backgroundColor: '#fffcd1',
                                marginLeft: 5,
                                marginRight: 5,
                                outlineStyle: 'none',
                                width: '98%',
                                textIndent: 5
                            }}
                            name={'networkParameters'} rows={20}
                            placeholder={'Input JSON string'}
                            value={this.state.networkParameters}
                            onChange={this.handleInputChange.bind(this)}/>
                        <br/>
                        <br/>
                        <div>
                            <Button type="primary" icon="cloud-download" loading={this.state.doing}
                                    onClick={this.updateServersCache.bind(this)}>
                                Find Nodes
                            </Button>
                            <Divider type="vertical"/>
                            <Button type="primary" icon="align-left"
                                    onClick={() => this.setState({showJSONFormatModal: true})}>
                                Format JSON
                            </Button>
                        </div>
                        <div id={'executeTips'}></div>
                    </Col>
                </Row>


                <Modal
                    width={1200}
                    style={{top: 10}}
                    title={this.state.selectedKey}
                    visible={this.state.showConfirmModal}
                    onOk={() => this.setState({showConfirmModal: false})}
                    onCancel={() => this.setState({showConfirmModal: false})}>
                    <Row>
                        <Col span={12}>
                            <Spin spinning={this.state.redisLoading}>
                                <div>
                                    <ReactJson src={this.state.selectedRedisValue}
                                               name={'Redis'}
                                               groupArraysAfterLength={1000}
                                               collapseStringsAfterLength={36}
                                               name={false} displayDataTypes={false}  theme="monokai"/>
                                </div>
                            </Spin>
                        </Col>
                        <Col span={12}>
                            <Spin spinning={this.state.memcachedLoading}>
                                <div>
                                    <ReactJson src={this.state.selectedMemcachedValue}
                                               name={'Memcached'}
                                               groupArraysAfterLength={1000}
                                               collapseStringsAfterLength={36}
                                               name={false} displayDataTypes={false}  theme="monokai"/>
                                </div>
                            </Spin>
                        </Col>
                    </Row>
                </Modal>


                <Modal
                    width={950}
                    style={{top: 10}}
                    title="Format JSON"
                    visible={this.state.showJSONFormatModal}
                    onOk={() => this.setState({showJSONFormatModal: false})}
                    onCancel={() => this.setState({showJSONFormatModal: false})}>
                    <div>
                        <ReactJson src={this.state.formatJSON}
                                   groupArraysAfterLength={1000}
                                   name={false} displayDataTypes={false}  theme="monokai"/>
                    </div>
                </Modal>

            </div>
        )
    }

}
